<template>
  <div class="folde">
    <Contextmenu :disabled="check || disabled" @itemCheck="itemCheck">
      <div class="info-content-item" :class="{ 'check-status': check, 'is-check': checked && check }">
        <div @click.stop.prevent="selectCheckBox" class="folde-checkbox" v-if="!disabled">
          <el-checkbox v-if="check" v-model="checked"></el-checkbox>
          <!-- <el-checkbox  v-model="checked"></el-checkbox> -->
        </div>
        <div class="folde-content" :class="{ 'opacity-style': checked && check }" @click="selectEle">
          <!-- <img v-if="AMOS_file && type == 2" class="star" src="image/file/amos.png" alt="" /> -->
          <img v-if="!isRedy" class="folde-img" :src="type === 1 ? (dataset.number_of_child_files ? 'image/file/img_folde.png' : 'image/file/img_empty_folde.png') : getFileTypeUrl(attachment_type)" alt="" />
          <img v-else class="folde-img" :src="getFileTypeUrl(getFilName.slice(getFilName.lastIndexOf('.') + 1))" alt="" />
          <!-- <div class="status" v-if="type === 2" :class="{[`type-${approval_status}`]:true}">{{getApprovalStatus(approval_status)}}</div> -->
          <div class="folde-name" @mouseover="handleMouseover" @mouseleave="handleMouseleave" @mousemove="handleMousemove">
            <p class="folde-name-text" ref="name" :class="{ oversize: nameOversizeLock, 'upload-text': isRedy }">{{ getFilName }}</p>
          </div>
        </div>
        <div class="tooltip-name" v-if="tooltipLock && nameOversizeLock" :style="{ left: nameLeft + 'px', top: nameTop + 'px' }" @click="selectEle">
          <p>{{ getFilName }}</p>
        </div>
        <!-- 文件上传时的loading状态 "-->
        <LoadingRadio :percentage="loading" v-if="loading > 0" @stopUpload="stopUpload"></LoadingRadio>
        <div class="btns-label" v-if="toolShow || popoverShow">
          <div class="btns" @click.stop>
            <span v-for="item in outBtn(dataset)" class="item-child" :class="{ del: item.type === 'del' }" @click="btnCheck(item, dataset)" :key="item.value">{{ item.label }}</span>
          </div>
          <el-popover @click.native.stop placement="bottom" v-if="inBtn(dataset) && inBtn(dataset).length > 0" popper-class="info-file-able info-file-popover" :key="dataset.id" ref="gridTable" v-model="popoverShow" trigger="click">
            <span slot="reference" @click.stop="closePopover">更多</span>
            <div class="item-box">
              <div v-for="item in inBtn(dataset)" :key="item.value" class="item-child" :class="{ del: item.type === 'del' }" @click="btnCheck(item, dataset)"><i :class="`icon iconfont ${item.icon}`"></i>{{ item.type === "del" ? (type === 1 ? "删除文件夹" : "删除文件") : item.label }}</div>
            </div>
          </el-popover>
        </div>
      </div>
    </Contextmenu>
    <!-- 弹窗提示 -->
    <AlertDialog title="所选文件夹不为空，不能执行删除操作。" v-model="alertDialog"></AlertDialog>
  </div>
</template>
<script>
import Contextmenu from "@/components/contextmenu";
import DelDialog from "./delDialog";
import { mapState, mapMutations } from "vuex";
import LoadingRadio from "./loadingRadio";
import AlertDialog from "./alertDialog";
import bus from "@/bus";
export default {
  props: {
    dataset: {
      type: [Array, Object],
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    listTool: {
      type: Array,
      default: () => ["restname", "uploadNewFile", "upload", "amos", "del"],
    },
    showDetail: {
      type: Boolean,
      default: true,
    },
    loading: {
      tyoe: Number,
      default: 0,
    },
    isRedy: {
      type: Boolean,
      default: false,
    },
    toolObj: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    checked(val) {
      this.$emit("change", { checked: val, id: this.dataset.id });
    },
    popoverShow(val) {
      if (this.checked) return; // 选中时不要失去选择状态
      this.check = val;
    },
  },
  components: {
    Contextmenu,
    DelDialog,
    LoadingRadio,
    AlertDialog,
  },
  // inject: ["getApprovalStatus"],
  computed: {
    getFilName() {
      // 获取文件名称
      return (this.type === 1 ? this.dataset?.folder_name : this.dataset?.attachment_name) || this.dataset.name || this.dataset.attachment_name || this.dataset.title;
    },
    ...mapState("info/info", {
      infoTag: (state) => state.infoTag,
    }),
    btns() {
      return this.toolObj.filter((res) => {
        return res.permissions(this.dataset);
      });
    },
    outBtn() {
      return (data) => {
        let arr = this.toolObj.filter((res) => {
          return !res.permissions || res.permissions(data);
        });
        if (arr.length > 0) {
          return arr.slice(0, 1);
        } else {
          return [];
        }
      };
    },
    inBtn() {
      return (data) => {
        let arr = this.toolObj.filter((res) => {
          return !res.permissions || res.permissions(data);
        });
        if (arr.length > 1) {
          return arr.slice(1);
        } else {
          return [];
        }
      };
    },
    type() {
      return this.dataset?.type;
    },
    AMOS_file() {
      return this.dataset?.AMOS_file || this.dataset?.file_cabinet?.AMOS_file;
    },
    attachment_type() {
      return this.dataset?.attachment_type;
    },
    approval_status() {
      return this.dataset?.approval?.approval_status || this.dataset?.approval?.approval_status;
    },
  },
  mounted() {
    if (this.dataset.checked) {
      this.checked = true;
      this.check = true;
    }
    this.nameOversizeFn();
    bus.$on("doClose", () => {
      this.$refs.gridTable ? this.$refs.gridTable.doClose() : "";
    });
  },
  updated() {
    this.nameOversizeFn();
  },
  data() {
    return {
      foldCheck: false,
      dialogVisible: false,
      restnameVisible: false,
      deldialogVisible: false,
      alertDialog: false,
      tooltipLock: false,
      nameLeft: 0,
      nameTop: 0,
      nameOversizeLock: false,
      check: false,
      checked: false,
      popoverShow: false,
      toolShow: false,
    };
  },
  methods: {
    // ...mapMutations("info/info", ["ADD_TAG"]),
    clearSelection() {
      if (this.dataset.checked) {
        this.checked = false;
        this.check = false;
      }
    },
    nameOversizeFn() {
      if (this.$refs.name.offsetHeight > 40) {
        this.nameOversizeLock = true;
      }
    },
    getHeadText(data) {
      // 去除后缀的文件名称
      let length = data.lastIndexOf(".");
      if (length > -1) {
        let idx = length - 2;
        return idx < 1 ? data.lastIndexOf(".") : idx;
      } else {
        return data;
      }
    },
    selectCheckBox() {
      this.$refs.gridTable ? this.$refs.gridTable.doClose() : "";
      if (this.check) {
        // 进入全选状态时
        this.checked = !this.checked;
      }
    },
    selectEle() {
      // 文件点击
      // if (this.check) { // 进入全选状态时
      //   this.checked = !this.checked
      // } else
      if (this.type === 1) {
        // 文件夹被点击
        // this.ADD_TAG(this.dataset);
        this.$emit("click", this.dataset);
      } else if (this.showDetail) {
        // 文件点击
        this.dialogVisible = true;
        this.$emit("openDetail", this.dataset);
      } else if (this.type === 2 && !this.showDetail && this.canPreview(this.dataset?.attachment_type)) {
        // 预览文件
        this.getOssUrl(this.dataset.oss_attachment_name, (data) => {
          this.opendImgUrl(this.dataset.attachment_type, data.sign_url);
        });
      }
    },
    restName() {
      this.$emit("restName", this.dataset);
    },
    setAMOS(isMark) {
      // 标记AMOS
      this.$emit("setAMOS", { isMark, data: this.dataset });
    },
    restNameSuccess() {
      this.$emit("restNameSuccess");
    },
    uploadNewFile() {
      this.$emit("uploadNewFile", this.dataset);
    },
    getBlobUrl(content) {
      // 获取文件url
      const blob = new Blob([content]);
      return URL.createObjectURL(blob);
    },
    delFolde() {
      // 删除文件夹
      this.$emit("delFile", this.dataset);
    },
    handleMouseover() {
      this.tooltipLock = true;
      // console.log(this.$refs.name)
    },
    handleMouseleave() {
      this.tooltipLock = false;
    },
    handleMousemove(e) {
      this.nameLeft = e.pageX + 20;
      this.nameTop = e.pageY + 20;
    },
    stopUpload() {
      this.$emit("stopUpload", this.dataset);
    },
    itemCheck(val) {
      this.toolShow = val;
      if (this.checked || this.popoverShow) return;
      // if(!val) {
      //   this.$refs.gridTable ? this.$refs.gridTable.doClose() : ''
      // }
      this.$nextTick(() => {
        this.check = val;
      });
    },
    btnCheck(val) {
      this.$refs?.gridTable?.doClose();
      val.fn(this.dataset);
    },
    closePopover() {
      bus.$emit("doClose");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/mixin";
// .info-file-popover{
//   margin:0 !important;
//   padding-top:16px;
// }
.folde {
  position: relative;
  .item-box {
    // padding: 8px 0;
    .item-child {
      height: 40px;
      padding-left: 16px;
      line-height: 40px;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      margin: 4px 0;
      box-sizing: border-box;
      &:hover {
        background-color: $colorStatus_hoverBackColor;
        color: $colorStatus-hoverColor;
      }
      &:active {
        background-color: $colorStatus-activeBackColor;
        color: $colorStatus-activeColor;
      }
      .icon {
        margin-right: 16px;
      }
    }
    .item-child:first-child {
      margin-top: 8px;
    }
    .item-child:last-child {
      margin-bottom: 8px;
    }
    .del {
      color: #ff3939;
      &:hover {
        color: #ff3939;
      }
      &:active {
        color: #ff3939;
      }
    }
  }
  .info-content-item {
    box-sizing: border-box;
    width: 160px;
    height: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 11px;
    line-height: 1;
    cursor: pointer;
    border-radius: 4px;
    position: relative;
    border: 1px solid #fff;
    padding: 0 16px;
    transition: all 0.3s;
    // &:hover {
    //   background-color: #f7f8f9;
    // }
    // &:active {
    //   background-color: #ecedee;
    // }
    .folde-checkbox {
      position: absolute;
      top: 4px;
      right: 4px;
    }
    .status {
      width: 50px;
      height: 20px;
      border-radius: 2px;
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      position: absolute;
      bottom: 71px;
      left: 54px;
      margin-left: 0 !important;
    }
    .folde-img {
      width: 54px;
      height: 54px;
      margin-top: 16px;
    }
    .star {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 13px;
      left: 51px;
      margin: 0 !important;
    }
    .folde-name {
      box-sizing: border-box;
      font-size: 14px;
      line-height: 1.3;
      font-weight: 400;
      margin-top: 10px;
      color: rgba(32, 32, 40, 0.8);
      width: 100%;
      display: flex;
      justify-content: center;
      .folde-name-text {
        font-size: 14px;
        word-wrap: break-word;
        word-break: break-all;
        text-align: center;
        &.oversize {
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      .upload-text {
        @include ellipsis();
      }
    }
  }
  .rest-item {
    cursor: auto;
    &:hover,
    &:active {
      background-color: initial;
    }
  }
  .check-status {
    border: 1px solid rgba(32, 32, 40, 0.08);
    box-shadow: 0px 2px 16px 0px rgba(32, 32, 40, 0.1);
  }
  .is-check {
    border: 1px solid $color-active;
  }
  .opacity-style {
    opacity: 0.6;
  }
  .folde-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .upload-oss-file {
    display: none;
  }
  .folde-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -70%);
  }
  .tooltip-name {
    position: fixed;
    background: rgba(13, 31, 60, 0.8);
    border-radius: 2px;
    box-shadow: 0px 2px 4px 0px rgba(117, 116, 142, 0.2);
    font-size: 12px;
    color: #ffffff;
    line-height: 14px;
    font-weight: 400;
    padding: 7px 16px;
    max-width: 300px;
    z-index: 100;
    p {
      word-wrap: break-word;
      word-break: break-all;
    }
  }
  .btns-label {
    display: flex;
    align-items: center;
    font-size: 12px;
    width: 100%;
    bottom: 8px;
    position: absolute;
    justify-content: center;
    > * {
      margin-left: 16px;
    }
    > *:first-child {
      margin: 0;
    }
    .btns {
      display: flex;
      align-items: center;
      span {
        color: $color-active;
        cursor: pointer;
        flex-shrink: 0;
        &:active {
          color: $colorStatus_activeColor;
        }
      }
      span:not(:last-child) {
        margin-right: 40px;
      }
      .del {
        color: #ff3939;
      }
    }
    .el-popover__reference {
      color: $color-active;
      cursor: pointer;
      flex-shrink: 0;
      &:active {
        color: $colorStatus_activeColor;
      }
    }
  }
  .el-checkbox__inner {
    background-color: #f1f2f3;
    border: 1px solid rgba(32, 32, 40, 0.4);
  }
  .status {
    width: 50px;
    height: 20px;
    border-radius: 2px;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
  }
  .type-3 {
    background-color: #ffe7e6;
    color: #ff3939;
  }
  .type-1 {
    background-color: #fff0d2;
    color: #ff8b23;
  }
  .type-2 {
    background-color: #edf7f4;
    color: $color-active;
  }
}
.info-file-able {
  .item-box {
    // padding: 8px 0;
    .item-child {
      height: 40px;
      padding: 0 16px;
      line-height: 40px;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      margin: 4px 0;
      i {
        font-size: 14px;
      }
      &:hover {
        background: #f7f8f9;
        color: initial;
      }
      &:active {
        background-color: #ecedee;
        color: initial;
      }
      .icon {
        margin-right: 16px;
      }
    }
    .text-disable {
      color: rgba(32, 32, 40, 0.4) !important;
    }
    .item-child:first-child {
      margin-top: 8px;
    }
    .item-child:last-child {
      margin-bottom: 8px;
    }
    .del {
      color: #ff3939;
      &:hover {
        color: #ff3939;
      }
      &:active {
        color: #ff3939;
      }
    }
  }
}
</style>
